import { Breakfast, Dinner, Lunch, Snacks } from "../../iconRef/mealPLanIcons";

const MealIcon = ({ mealType, width, height }: { mealType: string, width: number, height: number }) => {
    const normalizedMealType = mealType?.toLowerCase();

    switch (normalizedMealType) {
        case 'morning':
            return <Breakfast height={height} width={width} />;
        case 'afternoon':
            return <Lunch height={height} width={width} />;
        case 'night':
            return <Snacks height={height} width={width} />;
        case 'evening':
            return <Dinner height={height} width={width} />;
        default:
            return <Breakfast height={height} width={width} />;
    }
};

export default MealIcon;